// extracted by mini-css-extract-plugin
module.exports = {"CardGroup":"ReservationManagement_CardGroup__2mUxB","ReservationCards":"ReservationManagement_ReservationCards__1tL7U"};